<template>
  <div class="content">
    <div class="calendar-header">
      <i class="iconfont icon-jiantou_liebiaoxiangzuo_o" @click="changeYear(-1)"></i>
      <span>{{year}}</span>
      <i class="iconfont icon-jiantou_liebiaoxiangyou_o" @click="changeYear(1)"></i>
    </div>
    <div class="section-total">
      <p class="name">
        <i class="iconfont iconfont icon-fenlei-jixie" @click="changeYear(1)"></i>
        机械费（元）
      </p>
      <p class="ctt">{{machineTeamPriceTotal || 0}}</p>
    </div>
    <div class="calendar-body">
      <div class="item" v-for="(item, ind) in list" :key="'c' + ind">
        <div class="item-ctt" :class="{ isSelect: ind === currentIndex, 'item-click': item.machineTeamIds.length }" @click="chooseMonth(item.machineTeamIds, ind)">
          <p class="date"><span>{{item.month}}</span></p>
          <p class="ctt">{{item.machineTeamPrice || 0}}元</p>
        </div>
      </div>
    </div>
    <DetailList :idList="idList" :isShow.sync="showDetail"></DetailList>
  </div>
</template>

<script>
import DetailList from './DetailList'
export default {
  name: 'machine',
  components: { DetailList },
  data () {
    return {
      machineTeamPriceTotal: '0',
      year: this.$dayjs().format('YYYY'),
      currentIndex: -1,
      showDetail: false,
      list: []
    }
  },
  computed: {
    projectId () {
      return this.$store.state.projectId || ''
    },
    idList () {
      return this.currentIndex >= 0 && this.list[this.currentIndex] ? this.list[this.currentIndex].machineTeamIds : []
    }
  },
  watch: {
    projectId () {
      this.currentIndex = -1
      this.load()
    }
  },
  created () {
    this.load()
  },
  methods: {
    changeYear (num) {
      this.currentIndex = -1
      this.year = this.$dayjs(this.year).add(num, 'year').format('YYYY')
      this.load()
    },
    load () {
      this.$axios.get(this.$apis.machine.selectYhMachineMonthSum, {
        projectId: this.projectId,
        machineTeamYear: this.year
      }).then((res) => {
        this.machineTeamPriceTotal = res.machineTeamPriceTotal || 0
        this.list = res.monthList || []
      })
    },
    chooseMonth (ids, ind) {
      if (ids && ids.length) {
        if (this.currentIndex !== ind) {
          this.currentIndex = ind
        }
        this.showDetail = true
      }
    }
  }
}
</script>

<style scoped lang='scss'>
  .content {
    padding: 10px;
    .section-total {
      width: 278px;
      border: 1px solid #1AD1B0;
      margin: 10px auto;
      p {
        text-align: center;
        padding: 0 5px;
        &.name {
          position: relative;
          height: 24px;
          font-family: PingFang SC;
          font-weight: 600;
          font-size: 14px;
          color: #3563D9;
          line-height: 24px;
          background: #DCFAF5;
          .iconfont {
            position: absolute;
            left: 0;
            top: 0;
            font-size: 22px;
            &::before {
              -webkit-background-clip: text;
              background-clip: text;
              color: transparent;
              background-image: linear-gradient(-24deg, #C2EAD7, #D0F4E0);
            }
          }
        }
        &.ctt {
          height: 46px;
          font-family: DIN-BlackItalic;
          font-weight: 400;
          font-size: 30px;
          color: #3563D9;
          line-height: 46px;
        }
      }
    }
    .calendar-header {
      display: flex;
      justify-content: center;
      align-items: center;
      span {
        padding: 0 20px;
      }
      .iconfont {
        cursor: pointer;
      }
    }
    .calendar-body {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-wrap: wrap;
      border-bottom: 1px solid #EFEFEF;
      margin-top: 10px;
      .item {
        flex-shrink: 0;
        width: 25%;
        .item-click {
          cursor: pointer;
        }
        .item-ctt {
          border: 1px solid #EFEFEF;
          border-bottom-color: transparent;
          p {
            padding: 0 5px;
            line-height: 18px;
            &.date {
              width: 100%;
              height: 18px;
              color: rgba(0, 0, 0, 0.8);
              background: #F3F3F3;
              span {
                opacity: 0.5;
              }
            }
            &.ctt {
              display: flex;
              justify-content: right;
              align-items: flex-end;
              height: 36px;
              font-family: PingFang SC;
              font-weight: 400;
              font-size: 12px;
              color: #000000;
              padding: 5px 4px 2px 0;
            }
          }
          &.isSelect {
            .date {
              color: #1AD1B0;
              background: #DCFAF5;
            }
            border-color: #1AD1B0;
          }
        }
        &:first-child, & + .item:not(:nth-child(4n)) {
          .item-ctt:not(.isSelect) {
            border-right-width: 0;
          }
        }
      }
    }
  }
</style>
